import { getEventType } from './eventTypes'

interface EventTypePillProps {
  type: string
  variant?: 'filled' | 'bordered' | 'dot-only'
  size?: 'sm' | 'md'
  dim?: boolean
  className?: string
}

export function EventTypePill({
  type,
  variant = 'filled',
  size = 'sm',
  dim = false,
  className = '',
}: EventTypePillProps) {
  const t = getEventType(type)
  const h = size === 'sm' ? 24 : 28
  const fs = size === 'sm' ? 11.5 : 13
  const dotSize = size === 'sm' ? 7 : 8

  if (variant === 'dot-only') {
    return (
      <span
        className={className}
        style={{ width: dotSize, height: dotSize, borderRadius: '50%', background: t.color, display: 'inline-block', flexShrink: 0, opacity: dim ? 0.65 : 1 }}
      />
    )
  }

  const isFilled = variant === 'filled'

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        height: h,
        padding: `0 ${size === 'sm' ? 10 : 12}px`,
        borderRadius: 999,
        background: isFilled ? t.tint : 'transparent',
        border: isFilled ? 'none' : `1.5px solid ${t.color}`,
        color: t.color,
        fontSize: fs,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        letterSpacing: '0.01em',
        opacity: dim ? 0.65 : 1,
        flexShrink: 0,
      }}
    >
      <span style={{ width: dotSize, height: dotSize, borderRadius: '50%', background: t.color, flexShrink: 0 }} />
      {t.label}
    </span>
  )
}
